import * as React from 'react';
import { USERS_ROUTE } from '@sdk/common/constants';
import Avatar from '@sdk/components/avatar/Avatar';
import { User } from '@sdk/users/types/User';

import {
  MessageAlternativeLayout,
  MessageSidebar,
  MessageWrapper,
} from '@web/conversations/Message/MessageLayout/MessageLayout';

import { Name } from './messageAuthor.styles';

type Props = {
  author: User;
  children?: React.ReactNode;
};

export const MessageAuthor = ({ author, children }: Props) => (
  <MessageAlternativeLayout>
    <MessageSidebar>
      <Avatar user={author} />
    </MessageSidebar>

    <MessageWrapper>
      {children ?? <Name href={`${USERS_ROUTE}${author.id}`}>{author.fullname}</Name>}
    </MessageWrapper>
  </MessageAlternativeLayout>
);
